export default {
  chat: 'Онлайн-чат',
  feedback: 'Обратная связь',
  feedbackForm: {
    title: 'Что можно улучшить?',
    description:
      'Поделитесь своими идеями, пожеланиями или замечаниями. Мы хотим развивать edna Pulse так, чтобы эффективно решать ваши бизнес-задачи.',
    hint: 'Если вы заметили ошибку в работе edna Pulse или вам нужна помощь, напишите нам: <0>{{link}}</0>.',
  },
  feedbackModal: {
    title: 'Спасибо за обратную связь!',
    description: 'Ваши отзывы вдохновляют команду edna Pulse на новые свершения.',
  },
};
